import React from "react";
import { Collapse as MuiCollapse, styled } from "@mui/material";
import { CollapseProps } from "./types";
import { KeyboardArrowDown } from "@mui/icons-material";
import { Box } from "../Box";

const Collapse: React.FC<CollapseProps> = ({
  title,
  children,
  className,
  toggleIsOpen,
  isOpen,
  cursorPointerOnArrowOnly = false,
  hiddenArrow = false,
}) => {
  return (
    <StyledCollapse className={`collapse ${className}`} data-testid="collapse">
      <span
        className={`collapse-title ${isOpen && "open"}`}
        style={{
          cursor: hiddenArrow || cursorPointerOnArrowOnly ? "default" : "pointer",
        }}
        {...(!cursorPointerOnArrowOnly && { onClick: toggleIsOpen })}
      >
        {title}
        {!hiddenArrow && (
          <span
            className="collapse-icon"
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              cursor: "pointer",
            }}
            {...(cursorPointerOnArrowOnly && { onClick: toggleIsOpen })}
          >
            <KeyboardArrowDown />
          </span>
        )}
      </span>
      <MuiCollapse in={isOpen}>{isOpen && children}</MuiCollapse>
    </StyledCollapse>
  );
};

export default Collapse;
const StyledCollapse = styled(Box)(({ theme }) => ({
  transition: "all 0.5s",

  ".collapse-title": {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
  },
  ".collapse-title.open": {
    paddingBottom: "1rem",
  },

  ".collapse-icon svg": {
    color: theme.tokens.colors.gray[6],
    width: "24px",
  },
  fontFamily: theme.typography.fontFamily,
  width: "100%",
  backgroundColor: theme.tokens.colors.gray[1],
  color: theme.tokens.colors.gray[7],
}));
